import {PaymentMethodDao} from '../../dao';
import {PaymentMethodModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_PAYMENT_METHOD_BY_ID';

export async function updatePaymentMethodById(
    userData: Record<string, string>,
    paymentMethodId: number,
    update: Record<string, any>
) {
    try {
        const result = await PaymentMethodDao.updatePaymentMethodById(userData.userToken, paymentMethodId, update);

        const resultParsed = PaymentMethodModel.parsePaymentMethod(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
